"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameOptions = void 0;
const OPTION_DEFAULTS = {
    maxPlayerCount: 7, // impacts security rule checks of "managers" lists
    managerIsPlayer: true,
    collapseDuplicateAnswers: true,
    guessExactAnswerGivesBonus: false, // only implements false
    betUnit: 100, // $100 per bet
    betGrantCount: 2, // x betUnit
    bestAnswerGrantCount: 1, // x betUnit
    betsPerRound: 2, // max 32? (in security rules)
    betSpotCount: 7, // must be odd
    roundsPerGame: 5,
};
class GameOptions {
    constructor(ctx, opts = {}) {
        this.opts = OPTION_DEFAULTS;
        Object.assign(this.opts, OPTION_DEFAULTS, opts);
        ctx.assertGT(this.opts.maxPlayerCount, 0, 'maxPlayerCount must be greater than zero');
        ctx.assertGT(this.opts.betUnit, 0, 'betUnit must be greater than zero');
        ctx.assertGT(this.opts.betGrantCount, 0, 'betGrantCount must be greater than zero');
        ctx.assertGT(this.opts.bestAnswerGrantCount, 0, 'betAnswerGrantCount must be greater than zero');
        ctx.assertGT(this.opts.betsPerRound, 0, 'betsPerRound must be greater than zero');
        ctx.assertGT(this.opts.betSpotCount, 0, 'betSpotCount must be greater than zero');
        ctx.assertEqual((this.opts.betSpotCount % 2), 1, `betSpotCount (${this.opts.betSpotCount} must be odd`);
        ctx.assertGT(this.opts.roundsPerGame, 0, 'roundsPerGame must be greater than zero');
    }
    maximumNumberOfPlayers(_ctx) {
        return this.opts.maxPlayerCount;
    }
    managerIsPlayer(_ctx) {
        return this.opts.managerIsPlayer;
    }
    collapseDuplicateAnswers(_ctx) {
        return this.opts.collapseDuplicateAnswers;
    }
    betSpotCount(_ctx) {
        return this.opts.betSpotCount;
    }
    betUnit(_ctx) {
        return this.opts.betUnit;
    }
    betGrantCount(_ctx) {
        return this.opts.betGrantCount;
    }
    grantPerRound(_ctx) {
        return this.opts.betsPerRound * this.opts.betUnit;
    }
    betsPerRound(_ctx) {
        return this.opts.betsPerRound;
    }
    bestAnswerPayout(_ctx) {
        return this.opts.bestAnswerGrantCount * this.opts.betUnit;
    }
    roundsPerGame(_ctx) {
        return this.opts.roundsPerGame;
    }
    setRoundsPerGame(ctx, rounds) {
        ctx.assertGT(rounds, 0);
        ctx.assertLT(rounds, GameOptions.MAX_ROUNDS_PER_GAME); // Security rules depend on this bounds
        this.opts.roundsPerGame = rounds;
    }
    setBetsPerRound(ctx, bets) {
        ctx.assertGT(bets, 0);
        this.opts.betsPerRound = bets;
    }
    setGrantPerRound(ctx, grant) {
        ctx.assertGT(grant, 0);
        const betUnit = this.opts.betUnit;
        ctx.assertEqual((grant % betUnit), 0, `grantPerRound (${grant}) must be a multiple of betUnit (${betUnit})`);
        this.opts.betsPerRound = grant / betUnit;
    }
    clone(ctx) {
        return new GameOptions(ctx, this.opts);
    }
    toPersist(_ctx) {
        return {
            managerIsPlayer: this.opts.managerIsPlayer,
            maxPlayerCount: this.opts.maxPlayerCount,
            betSpotCount: this.opts.betSpotCount,
            betUnit: this.opts.betUnit,
            betGrantCount: this.opts.betGrantCount,
            bestAnswerGrantCount: this.opts.bestAnswerGrantCount,
            betsPerRound: this.opts.betsPerRound,
            roundsPerGame: this.opts.roundsPerGame,
            collapseDuplicateAnswers: this.opts.collapseDuplicateAnswers,
        };
    }
    static loadGameOptions(ctx, state) {
        return new GameOptions(ctx, state.options);
    }
}
exports.GameOptions = GameOptions;
GameOptions.MAX_ROUNDS_PER_GAME = 20;
//# sourceMappingURL=GameOptions.js.map